import { ADVANCED_KEY_METRICS, advancedGroups, advancedKeyMetrics, advancedMetricValue, advancedNumber } from './advancedStatistics';

export const COMPARISON_CATEGORIES = [
  { id: 'disciplina', featured: ['CARDS_YELLOW', 'CARDS_YELLOW_SECOND', 'CARDS_RED', 'FOULS_COMMITTED', 'FOULS_SUFFERED'] },
  { id: 'finalizacion',
    featured: ['EXPECTED_GOALS', 'GOALS', 'SHOTS_TOTAL', 'SHOTS_ON_TARGET', 'DERIVED_SHOT_ACCURACY', 'DERIVED_SHOT_CONVERSION'] },
  { id: 'defensa',
    featured: ['BALL_RECOVERIES', 'INTERCEPTIONS', 'TACKLES_WON', 'CLEARANCES', 'OUTFIELDER_BLOCKS', 'CHALLENGE_LOST'] },
  { id: 'pases',
    featured: ['PASSES_TOTAL', 'PASSES_ACCURACY', 'PASSES_ACCURATE', 'PASSES_FINAL_THIRD_ACCURACY', 'LONG_BALLS_ACCURACY', 'CROSSES_ACCURACY'] },
  { id: 'creacion',
    featured: ['EXPECTED_ASSISTS', 'ASSISTS_GOAL', 'BIG_CHANCES_CREATED', 'KEY_PASSES', 'TOUCHES_BOX_OPPOSITE', 'DERIVED_GOALS_ASSISTS'] },
  { id: 'regateDuelos',
    featured: ['DUELS_EFFICIENCY', 'DUELS_AERIAL_EFFICIENCY', 'DUELS_GROUND_EFFICIENCY', 'DRIBBLES_EFFICIENCY', 'DRIBBLES_WON', 'PROGRESSIVE_CARRIES'] },
  { id: 'porteria',
    featured: ['SAVES_TOTAL', 'GOALS_PREVENTED', 'GOALS_CONCEDED', 'HIGH_CLAIM_SAVED', 'KEEPER_SWEEPER_TOTAL', 'PENALTIES_SAVED'] },
];
const LOWER_IS_BETTER = new Set(['CHALLENGE_LOST', 'ERRORS_LEAD_TO_GOAL', 'ERRORS_LEAD_TO_SHOT',
  'BIG_CHANCES_MISSED', 'GOALS_CONCEDED', 'GOALS_OWN', 'FOULS_COMMITTED', 'PENALTIES_COMMITTED',
  'PENALTIES_NOT_CONVERTED', 'TURNOVERS', 'CARDS_YELLOW', 'CARDS_YELLOW_SECOND', 'CARDS_RED']);

function metricSample(metric, mode, minimum) {
  const matches = advancedNumber(metric?.partidosConDatos);
  const minutes = advancedNumber(metric?.minutosConDatos);
  const eligible = matches > 0 && ['suma', 'media', 'porcentaje'].includes(metric?.operacion)
    && (minimum <= 0 || minutes >= minimum)
    && (mode === 'totals' || metric.operacion !== 'suma' || minutes > 0);
  return {
    value: eligible ? advancedMetricValue(metric, mode === 'totals' ? 'suma' : 'por90', minimum) : null,
    matches, minutes,
    successes: advancedNumber(metric?.aciertos), attempts: advancedNumber(metric?.intentos),
  };
}

export function comparisonAdvancedCategories(players, { mode = 'rates', minimum = 0 } = {}) {
  if (!players[0]?.estadisticasAvanzadas?.fuente
    || players[0].estadisticasAvanzadas.fuente !== players[1]?.estadisticasAvanzadas?.fuente) return [];
  const categories = advancedGroups(players[0].estadisticasAvanzadas.total, 'player', null,
    players[1].estadisticasAvanzadas.total).map(group => ({
    id: group.id,
    featured: COMPARISON_CATEGORIES.find(category => category.id === group.id)?.featured || ADVANCED_KEY_METRICS,
    rows: group.metrics.map(metric => {
      const operation = metric.first?.operacion || metric.second?.operacion;
      const samples = [metric.first, metric.second].map(value => metricSample(value, mode, minimum));
      if (metric.first && metric.second && metric.first.operacion !== metric.second.operacion) {
        samples.forEach(sample => { sample.value = null; });
      }
      return {
        id: metric.id, operation, percent: operation === 'porcentaje' || metric.id === 'POSSESSION',
        direction: group.id === 'participacion' ? 0 : LOWER_IS_BETTER.has(metric.id) ? -1 : 1,
        samples, values: samples.map(sample => sample.value),
        derived: Boolean(metric.first?.derivada || metric.second?.derivada),
      };
    }),
  }));
  const rows = [...new Map(categories.flatMap(category => category.rows).map(row => [row.id, row])).values()];
  if (!rows.length) return [];
  return [
    { id: 'key', featured: ADVANCED_KEY_METRICS, rows: advancedKeyMetrics(rows) },
    ...categories,
    { id: 'all', featured: ADVANCED_KEY_METRICS, rows },
  ];
}

export function comparisonHighlights(category) {
  const ordered = [...category.rows].sort((a, b) => {
    const rank = row => {
      const index = category.featured.indexOf(row.id);
      return index < 0 ? category.featured.length : index;
    };
    return rank(a) - rank(b);
  });
  return [...ordered.filter(row => row.values.every(value => value !== null)),
    ...ordered.filter(row => row.values.some(value => value === null))].slice(0, 6);
}
